'use client';

import Script from 'next/script';

export interface GigPigAttributes {
  widgetKey: string;
  foregroundColour: string | undefined;
  backgroundColour: string | undefined;
  dark: boolean;
}

export function GigPigWidget({ widgetKey, foregroundColour, backgroundColour, dark }: GigPigAttributes) {
  return (
    <>
      <div
        id="gigpig-whatson"
        data-live="true"
        data-key={widgetKey}
        data-brand-text={foregroundColour?.replace('#', '')}
        data-brand-bg={backgroundColour?.replace('#', '')}
        data-dark={dark}
        data-hide-gig="true"
        // @ts-expect-error v2 is a custom attribute
        v2="true"
      />

      <Script
        defer
        src="https://widgets.gigpig.uk/js/widget.js"
        onLoad={() => {
          console.log('Script loaded successfully');
        }}
        onError={() => console.error('Failed to load the script')}
      />
    </>
  );
}
